import { render, staticRenderFns } from "./WarningSBDialog.vue?vue&type=template&id=0764ceb2&scoped=true"
import script from "./WarningSBDialog.vue?vue&type=script&lang=js"
export * from "./WarningSBDialog.vue?vue&type=script&lang=js"
import style0 from "./WarningSBDialog.vue?vue&type=style&index=0&id=0764ceb2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0764ceb2",
  null
  
)

export default component.exports